import React from 'react';
import { ReactComponent as Settings } from '../../assets/images/icons/setting.svg';

function SettingsIcon(props) {
  return (
    <Settings {...props} className={'icon'} />
  );
}

export default SettingsIcon;
